import React from "react";

interface IPromiseItemProps {
  promise: PromiseLike<any>
  mapper: (value: any) => any
}

interface IPromiseItemState {
  value?: any
}

export class PromiseItem extends React.Component<IPromiseItemProps, IPromiseItemState> {
  constructor(props: IPromiseItemProps) {
    super(props)

    this.state = {}
    props.promise.then((value) => {
      this.setState({ value })
    })
  }

  public render() {
    const { value } = this.state
    const { mapper } = this.props

    if (!value) {
      return null
    }

    return mapper(value)
  }
}
